import DynamicChatSuggestions from "./DynamicChatSuggestion";
export default DynamicChatSuggestions;
